<template>
    <div class="row">
        <template v-for="(item, key) in listArray">
            <check-item :icon="item.icon" :title="item.title" :text="item.text"></check-item>
            <div v-if="(key + 1)%2 === 0" class="w-100"></div>
        </template>
    </div>
</template>
<script>
    import CheckItem from './checkItem.vue';

    export default {
        props:['listArray'],
        components: {
            'check-item': CheckItem,
        }
    }
</script>